import type { UserSearchHistory } from "@prisma/client";
import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { UserFilterHint, UserWithSubscription } from "src/types/users";
import { mutate } from "swr";

export const FetchMeKey = "/users/me";

interface StateType {
  me: UserWithSubscription | null;
  searchHistory: UserSearchHistory[] | null;
  filterHints: UserFilterHint[] | null;
}

const initialState: StateType = {
  me: null,
  searchHistory: null,
  filterHints: null,
};

const UsersSlice = createSlice({
  name: "Users",
  initialState,
  reducers: {
    getMe: (state, action: PayloadAction<UserWithSubscription>) => {
      state.me = action.payload;
      mutate(FetchMeKey, action.payload, { revalidate: false });
    },
    getMeSearchHistories: (
      state,
      action: PayloadAction<UserSearchHistory[]>,
    ) => {
      state.searchHistory = action.payload;
    },
    updateFilterHints: (state, action: PayloadAction<UserFilterHint[]>) => {
      state.filterHints = action.payload;
    },
    logout: (state) => {
      state.me = null;
      state.searchHistory = null;
      mutate(FetchMeKey, null);
    },
  },
});

export const { getMe, getMeSearchHistories, logout } = UsersSlice.actions;

export default UsersSlice.reducer;
